// src/components/Pagination.js
import React, { useEffect } from "react";

const Pagination = ({
                        currentPage,
                        totalPages,
                        itemsPerPage,
                        onPageChange,
                        onItemsPerPageChange,
                        storageKey, // new prop for persisting itemsPerPage
                    }) => {
    // On mount, check localStorage for a saved itemsPerPage value
    useEffect(() => {
        if (storageKey) {
            const storedValue = localStorage.getItem(storageKey);
            if (storedValue) {
                const parsedValue = Number(storedValue);
                if (parsedValue !== itemsPerPage) {
                    onItemsPerPageChange(parsedValue);
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [storageKey]);

    // Whenever itemsPerPage changes, save it to localStorage
    useEffect(() => {
        if (storageKey) {
            localStorage.setItem(storageKey, itemsPerPage);
        }
    }, [itemsPerPage, storageKey]);

    const handleFirstPage = () => {
        if (currentPage !== 1) onPageChange(1);
    };

    const handlePrevPage = () => {
        if (currentPage > 1) onPageChange(currentPage - 1);
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) onPageChange(currentPage + 1);
    };

    const handleLastPage = () => {
        if (currentPage !== totalPages) onPageChange(totalPages);
    };

    return (
        <div className="pagination">
            <button
                onClick={handleFirstPage}
                disabled={currentPage === 1}
                className="btn-icon btn-paginate"
                title="First Page"
            >
                ««
            </button>
            <button
                onClick={handlePrevPage}
                disabled={currentPage === 1}
                className="btn-icon btn-paginate"
                title="Previous Page"
            >
                «
            </button>
            <select
                value={currentPage}
                onChange={(e) => onPageChange(Number(e.target.value))}
                className="pagination-select"
            >
                {Array.from({ length: totalPages }, (_, i) => (
                    <option key={i + 1} value={i + 1}>
                        Page {i + 1}
                    </option>
                ))}
            </select>
            <button
                onClick={handleNextPage}
                disabled={currentPage === totalPages}
                className="btn-icon btn-paginate"
                title="Next Page"
            >
                »
            </button>
            <button
                onClick={handleLastPage}
                disabled={currentPage === totalPages}
                className="btn-icon btn-paginate"
                title="Last Page"
            >
                »»
            </button>
            <div className="items-per-page">
                <select
                    value={itemsPerPage}
                    onChange={(e) => onItemsPerPageChange(Number(e.target.value))}
                    className="pagination-select"
                >
                    <option value="5">5 per page</option>
                    <option value="10">10 per page</option>
                    <option value="25">25 per page</option>
                    <option value="50">50 per page</option>
                </select>
            </div>
        </div>
    );
};

export default Pagination;
